import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'audiences'
const verb = 'get'

export default class OspreyAudienceSearchSuggestion extends BaseAction {
    constructor(dataKey) {
        const id = '27e8a26a-d992-4da1-ab9a-ae41e089dc3c'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getSearchSuggestion(params) {
        this.params = Object.assign({
            fields: 'id,name',
            sf: 'name',
            sd: 'asc'
        }, params)

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/audiences/audience-search-suggestion.js